import type { EntityType } from '@platform/entities/entity.class';
import { NodeAPI, sqlFilterIf } from '@platform/shared/rpc';
import { EmployeeEntity } from '@platform/entities/employee/employee.entity';
import { normalize } from '@platform/shared/helpers/formatters';
import { Dao } from '@platform/entities/dao.class';

export class EmployeeDao extends Dao<EmployeeEntity, typeof EmployeeEntity> {
    constructor(
        public entityClass: typeof EmployeeEntity,
        public customerTypeMode: number | null = null
    ) {
        super(entityClass);
    }

    protected async load(
        params: {
            sqlFilter?: string | null | undefined;
            id?: string | null | undefined;
        } & Record<string, any>
    ): Promise<EntityType<EmployeeEntity>[]> {
        const query_response = await NodeAPI.Rpc.readWithRefs(EmployeeEntity, {
            filters: [
                ...sqlFilterIf(params.id)`main_table.id = ${params.id}`,
                ...(params.sqlFilter ? [[params.sqlFilter.replace(/_main_table_/g, 'main_table')] as [string]] : []),
            ],
            legacy: true,
        });

        if (!query_response?.length) return query_response;

        if (params.id && query_response.length === 1 && normalize(query_response[0]?.person_id)) {
            const employeeList = await NodeAPI.Rpc.readWithRefs(EmployeeEntity, {
                filters: [
                    [
                        ` main_table.person_id = '${normalize(query_response[0]?.person_id)}' and main_table.id <> '${
                            params.id
                        }' and main_table.main = true `,
                    ],
                ],
                legacy: true,
            });

            if (employeeList?.length) {
                query_response[0].isMultipleEmployee = true;
                query_response[0].multipleEmployeeName = employeeList
                    .map(
                        (i) =>
                            ` ${i.name ?? '-'} (${
                                typeof i?.employee_department_id === 'object' && i?.employee_department_id?.name
                                    ? i?.employee_department_id?.name
                                    : '-'
                            }, ${
                                typeof i?.employee_post_id === 'object' && i?.employee_post_id?.name
                                    ? i?.employee_post_id?.name
                                    : '-'
                            })`
                    )
                    .filter((i) => !!i)
                    .join();
            }
        }

        return query_response;
    }
}
